import { AriksaAIApiChatRequest, ChatResponse } from '@ariksa/ai-engine/api';
import {
  CloudInsight,
  CloudInsightApiGetCloudInsightsRequest,
  InsightV2ApiInsightV2Request,
  InsightV2Pagination,
} from '@ariksa/inventory-core/api';
import { call } from 'redux-saga/effects';
import { QueryContext } from 'services/utils/QueryContext';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import { AIEngineService, InventoryService } from 'api/services';
import { doGetEOLSoftware } from 'containers/Dashboard/VulnerabilityOverview/saga';

import { actions } from './slice';

export function* conversationalAISaga() {
  yield takeLatestAction(actions.getCloudInsight, doGetCloudInsights);
  yield takeLatestAction(actions.getEOLSoftware, doGetEOLSoftware);
  yield takeLatestAction(actions.askAI, doAskAI);
  yield takeLatestAction(actions.getResourceInsight, doGetResourceInsights);
}

export function* doAskAI(
  ctx: QueryContext<ChatResponse, AriksaAIApiChatRequest>,
) {
  yield call(ctx.fetch, () => AIEngineService.AriksaAI.chat(ctx.params));
}

export function* doGetCloudInsights(
  ctx: QueryContext<CloudInsight[], CloudInsightApiGetCloudInsightsRequest>,
) {
  yield call(
    ctx.fetch,
    () => InventoryService.CloudInsight.getCloudInsights(ctx.params),
    { errorMsg: 'Failed to get cloud insights!' },
  );
}

export function* doGetResourceInsights(
  ctx: QueryContext<InsightV2Pagination, InsightV2ApiInsightV2Request>,
) {
  yield call(
    ctx.fetch,
    () => InventoryService.InsightV2.insightV2(ctx.params),
    { errorMsg: 'Failed to get resource insights!' },
  );
}
